export default __webpack_public_path__ + "static/media/thumb002.846c4fa3.png";